import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { observer } from "mobx-react-lite";

import { Question } from "../../svg/svgImageList";
import useThemeService from "../../../services/theme-service/ThemeService";
import { PubSubEvents } from "../../../services/PubSubEvents";
import { warningLeavePageService } from "../../../services/page/WarningLeavePageService";
import { Dialog } from "../../dialog/Dialog";

export const WarningLeavePage = observer(() => {
  const history = useHistory();
  const { themeClass } = useThemeService();

  const dirty = warningLeavePageService.isDirty;
  const isSubmitting = warningLeavePageService.isSubmitting;

  const [shouldShowWarning, setShouldShowWarning] = useState(false);
  const [nextUrl, setNextUrl] = useState("");

  const iconQuestion = useMemo(() => {
    return {
      svg: Question,
      width: 30,
      height: 30,
      className: themeClass(["icon-question"]),
    };
  }, [themeClass]);

  const shouldWarnUser = useMemo(() => {
    return !isSubmitting && dirty;
  }, [dirty, isSubmitting]);

  const leavePage = useCallback(() => {
    PubSub.publish(PubSubEvents.ConfirmLeavePage);
    history.block(() => {});
    history.push(nextUrl);
    warningLeavePageService.reset();
  }, [history, nextUrl]);

  const cancelLeavePage = useCallback(() => {
    setShouldShowWarning(false);
    PubSub.publish(PubSubEvents.CancelLeavePage);
  }, []);

  useEffect(() => {
    let unregisterHistoryBlock = () => {};

    if (shouldWarnUser) {
      window.onbeforeunload = () => true;
      unregisterHistoryBlock = history.block((e: any) => {
        setNextUrl(e);
        setShouldShowWarning(true);
        return false;
      });
    } else {
      window.onbeforeunload = () => undefined;
      setShouldShowWarning(false);
      unregisterHistoryBlock = history.block(() => {});
    }

    return () => {
      unregisterHistoryBlock();
    };
  }, [history, shouldWarnUser]);

  return (
    <Dialog
      isVisible={shouldShowWarning}
      onHide={cancelLeavePage}
      iconTitle={iconQuestion}
      titleKey="general.leave-page-warning.title"
      subTextKey="general.leave-page-warning.message"
      buttonOk={{
        textKey: "general.leave-page-warning.ok",
        action: leavePage,
      }}
      buttonCancel={{
        textKey: "general.stay",
        action: cancelLeavePage,
      }}
    />
  );
});
